// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"540bd904","94":"98d555d7","239":"3fec4b50","259":"8a521c97","451":"27e62234","512":"97629025","525":"a19eb20d","553":"abb53156","792":"ecfc1686","907":"dfdf4e1b","964":"676ebfb1","965":"44482250"}[chunkId] + ".chunk.js";
};